import React from "react";
import "./Photos.css"

export default function Photos(props) {
    if (props.photos) {
        return (
            <section className="Photos">
                {/* creating a grid for the images */}
                <div className="row">
                    {/* looping through the images */}
                    {props.photos.map(function (photo, index) {
                        return (
                            <div className="col-4" key={index}>
                                {/* image link to be accessed on the original website */}
                                <a href={photo.src.original}
                                target="_blank" rel="noreferrer">
                                    {/* display the image, in landscape mode */}
                                    <img src={photo.src.landscape}
                                    className="img-fluid"
                                    alt="representative_photo" />
                                </a>
                            </div>
                        );
                    })}
                </div>
            </section>
        );
    }
    // if there are no photos to display, return null
    else {
        return null;
    }
}